import ItemRateDataForm from "./item-rate-data-form"

export default ItemRateDataForm
